import React from "react";
import "../NFTDetailDesign.css";
import SkeletonLoading from "../../Layouts/SkeletonLoading/SkeletonLoading";
const CommentSkelon = ({ id }) => {

    return (
        <div>
            {new Array(8).fill(1).map((_, index) => (
                <div key={index} className="d-flex align-items-start mb-3">
                    <div className="me-2">
                        <SkeletonLoading style={{ width: 40, height: 40, borderRadius: "50%", display: "block" }} />
                    </div>
                    <div className="w-100" style={{ textAlign: "left" }}>
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="w-100" style={{ textAlign: "left" }}>
                                <SkeletonLoading style={{ width: 140, height: 12, marginBottom: 6, display: "block" }} />
                                <SkeletonLoading style={{ width: 90, height: 10, display: "block" }} />
                            </div>
                        </div>
                        <div className="mt-2" style={{ textAlign: "left" }}>
                            <SkeletonLoading style={{ width: "90%", height: 12, marginBottom: 6, display: "block" }} />
                            {/* <SkeletonLoading style={{ width: "65%", height: 12, display: "block" }} /> */}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

const LoadMoreCommentSkelon = ({ id }) => {

    return (
        <div>
            {new Array(8).fill(1).map((_, index) => (
                <div key={index} className="d-flex align-items-start mb-3">
                    <div className="me-2">
                        <SkeletonLoading style={{ width: 40, height: 40, borderRadius: "50%", display: "block" }} />
                    </div>
                    <div className="w-100" style={{ textAlign: "left" }}>
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="w-100" style={{ textAlign: "left" }}>
                                <SkeletonLoading style={{ width: 140, height: 12, marginBottom: 6, display: "block" }} />
                                <SkeletonLoading style={{ width: 90, height: 10, display: "block" }} />
                            </div>
                        </div>
                        <div className="mt-2" style={{ textAlign: "left" }}>
                            <SkeletonLoading style={{ width: "90%", height: 12, marginBottom: 6, display: "block" }} />
                            {/* <SkeletonLoading style={{ width: "65%", height: 12, display: "block" }} /> */}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default CommentSkelon;
export { LoadMoreCommentSkelon };